import { useQuery } from '@apollo/client';
import { countryToRelavanceWord } from '@application/types';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type {
  AdoptionsLandingGetLittersQuery,
  AdoptionsLandingGetLittersQueryVariables,
} from '@gql/graphql';
import { CountryCode, LitterOrderByRelevanceFieldEnum, SortOrder } from '@gql/graphql';
import { useMemo } from 'react';
import { useLitterWhereBuilder } from '../../LitterListPageController/api/useLitterWhereBuilder';

export const ADOPTIONS_LANDING_GET_LITTERS = graphql(`
  query AdoptionsLandingGetLitters(
    $take: Int
    $where: LitterWhereInput
    $orderBy: [LitterOrderByWithRelationAndSearchRelevanceInput!]
    $litterCardInfoImgsTake: Int!
    $litterCardInfoTranslationsWhere: LitterTranslationWhereInput!
    $litterCardInfoBreedTranslationsWhere: DogBreedTranslationWhereInput!
  ) {
    findManyLitter(take: $take, where: $where, orderBy: $orderBy) {
      ...LitterCardInfo
    }
  }
`);

export const useGetLitters = () => {
  const { language, countryCode } = useRouter();
  const { litterWhereBuilder } = useLitterWhereBuilder();

  const variables = useMemo((): AdoptionsLandingGetLittersQueryVariables => {
    return {
      take: 4,
      where: {
        ...litterWhereBuilder(),
      },
      orderBy: [
        ...(countryCode !== CountryCode.EU
          ? [
              {
                _relevance: {
                  fields: [LitterOrderByRelevanceFieldEnum.tags],
                  search: countryToRelavanceWord[countryCode],
                  sort: SortOrder.desc,
                },
              },
            ]
          : []),

        { createdAt: SortOrder.desc },
      ],
      litterCardInfoImgsTake: 1,
      litterCardInfoTranslationsWhere: { language: { equals: language } },
      litterCardInfoBreedTranslationsWhere: { language: { equals: language } },
    };
  }, [language, countryCode, litterWhereBuilder]);

  const { data, error, loading } = useQuery<
    AdoptionsLandingGetLittersQuery,
    AdoptionsLandingGetLittersQueryVariables
  >(ADOPTIONS_LANDING_GET_LITTERS, {
    variables,
  });

  return {
    litters: data?.findManyLitter ?? [],
    littersError: error,
    littersLoading: loading,
    littersVariables: variables,
  };
};
